import HInput from './HInput';

export default HInput;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HInput/index.js